import { render, staticRenderFns } from "./ProductFilter.vue?vue&type=template&id=3d7cae5c&scoped=true&"
import script from "./ProductFilter.vue?vue&type=script&lang=js&"
export * from "./ProductFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7cae5c",
  null
  
)

export default component.exports